<template>
  <div class="main-content" autocomplete="off">
    <div>
      <b-row>
        <b-col md="8">
          <h2 class="page-title">
            Users
            <small class="add-new">
              <router-link to="/users/addUser">
                <i class="nav-icon i-Add"></i>
                <span v-if="userIsAdmin" class="item-name"> Add User</span>
              </router-link>
            </small>
          </h2>
        </b-col>
        <b-col md="4">
          <b-form-input
            v-model="searchWord"
            class="form-control-rounded"
            type="text"
            required
            placeholder="Search..."
          ></b-form-input>
        </b-col>
      </b-row>
      <div v-show="!loading" v-if="constructing">
        <b-table
          sticky-header
          class="custom-table"
          striped
          th-class="cursor-pointer"
          hover
          bordered
          responsive
          :items="filteredUsers"
          :fields="fields"
        >
          <template v-slot:cell(avatar)="row">
            <avatar :user="row.item" :hide-nick-name="true" />
          </template>
          <template v-slot:cell(roles)="row">
            <b-col v-for="role in row.item.roles" :key="role" md="2">
              <b-badge variant="outline-info">
                {{ role }}
              </b-badge>
            </b-col>
          </template>
          <template v-slot:cell(actions)="row">
            <div class="actions">
              <b-button
                v-if="userIsAdmin"
                size="sm"
                variant="success"
                @click="$router.push(`/users/addUser/${row.item.id}`)"
              >
                Edit
              </b-button>
              <b-button
                v-if="userIsAdmin"
                size="sm"
                variant="warning"
                @click="$router.push(`/Leave/Apply/${row.item.id}`)"
              >
                Record Leave
              </b-button>
              <ApolloMutation
                :mutation="
                  require('@/graphql/Account/sendForgotPasswordEmail.gql')
                "
                :variables="{
                  email: row.item.email
                }"
                @done="sendEmailSuccess"
              >
                <template v-slot="{ mutate }">
                  <b-button
                    v-if="userIsAdmin"
                    size="sm"
                    variant="info"
                    class="action-btn"
                    @click="mutate()"
                  >
                    Reset password
                  </b-button>
                </template>
              </ApolloMutation>
              <b-button
                v-if="userIsSuperAdmin"
                size="sm"
                variant="danger"
                @click="deleteUserTrigger(row.item.id)"
              >
                Delete
              </b-button>
            </div>
          </template>
        </b-table>
      </div>
    </div>

    <b-modal
      ref="modalDeleteUser"
      centered
      :hide-footer="true"
      :hide-header="true"
      size="lg"
    >
      <div class="modal-addition-only">
        <b-form-input
          readonly
          class="dark-placeholder form-control-rounded input-extra-large"
          type="text"
          :placeholder="
            `Are you sure you want to delete User: ${deleteUser.firstName}?`
          "
        ></b-form-input>
        <ApolloMutation
          :mutation="require('@/graphql/Account/DeleteUser.gql')"
          :variables="{
            userId: deleteUser.id
          }"
          @done="deletedSuccess"
        >
          <template v-slot="{ mutate }">
            <div class="modal-flex">
              <b-button
                class="col-md-2 "
                variant="success ripple"
                @click="$refs.modalDeleteClient.hide()"
              >
                Cancel
              </b-button>
              <b-button
                variant="danger ripple"
                class="col-md-2 delete-modal-btn"
                @click="mutate()"
              >
                Confirm
              </b-button>
            </div>
          </template>
        </ApolloMutation>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"
import avatar from "@/components/projectAvatar"

export default {
  name: "ManageUsers",
  components: {
    avatar
  },
  apollo: {
    users: {
      query: require("@/graphql/Account/GetUsers.gql"),
      update(data) {
        setTimeout(() => {
          this.constructing = true
          this.$nextTick(() => {
            this.loading = false
          })
        }, 500)
        return data.users
      }
    }
  },
  data() {
    return {
      loading: true,
      constructing: false,
      searchWord: "",
      deleteUser: {},
      fields: []
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "getCurrentUser"
    }),
    userIsAdmin() {
      return (
        this.currentUser?.roles?.includes("Admin") ||
        this.currentUser?.roles?.includes("Super Admin")
      )
    },
    userIsSuperAdmin() {
      return this.currentUser?.roles?.includes("Super Admin")
    },
    filteredUsers() {
      return this.users.filter(
        x =>
          !x.firstName.includesLowerCase("**") &&
          (x.firstName.includesLowerCase(this.searchWord) ||
            x.lastName.includesLowerCase(this.searchWord))
      )
    }
  },
  created() {
    this.fields = [
      { key: "Avatar" },
      { key: "firstName", sortable: true },
      { key: "lastName", sortable: true },
      { key: "email", sortable: true },
      { key: "roles", sortable: true },
      { key: "Actions" }
    ]
  },
  methods: {
    ...mapMutations({
      removeUser: "removeUser"
    }),
    sendEmailSuccess() {
      this.$toasted.success("Reset email sent")
    },
    /**
     *
     * @param userId
     */
    deleteUserTrigger(userId) {
      this.deleteUser = this.users.find(x => x.id == userId)
      this.$dialog({
        title: `Delete: ${this.deleteUser.firstName} ${this.deleteUser.lastName}`,
        content: "You're about to delete this User",
        btns: [
          {
            label: "Go ahead",
            color: "#3f51b5",
            callback: () => {
              this.$apollo
                .mutate({
                  mutation: require("@/graphql/Account/DeleteUser.gql"),
                  variables: {
                    userId: this.deleteUser.id
                  }
                })
                .then(() => {
                  this.deletedSuccess()
                })
            }
          },
          {
            label: "Cancel",
            color: "#444",
            ghost: true
          }
        ]
      })

      // this.$refs.modalDeleteUser.show()
    },
    deletedSuccess() {
      this.$toasted.success("User removed successfully")
      //Remove user from users list
      this.lodash.remove(this.users, user => {
        return user.id === this.deleteUser.id
      })
      this.users = this.users.map(x => x) //Needed to update the table's state
      this.$refs.modalDeleteUser.hide()

      //Remove user from Vuex store
      this.removeUser(this.deleteUser)

      //Done to not show 'undefined' in modal while closing
      setTimeout(() => {
        this.deleteUser = {}
      }, 1000)
    }
  }
}
</script>

<style scoped>
.modal-addition-only {
  display: flex;
  flex-direction: column;
}
.modal-body {
  background: white;
}
.modal-flex {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3rem;
}
/* .delete-modal-btn {
  margin-left: 10%;
} */
.actions {
  padding: 1rem;
  text-align: center;
}

div.actions > button {
  margin: 0.2rem 0;
  width: 100%;
}

.action-btn {
  margin: 0.2rem 0;
  width: 100%;
}
@media screen and (min-width: 2000px) {
  div.actions > button {
    width: 70% !important;
  }
  .action-btn {
    width: 70% !important;
  }
}

.save-btn {
  margin-top: 1rem;
}
.dark-placeholder::placeholder {
  color: black;
}
</style>
<style>
div.custom-table > table > thead > tr > th:last-of-type {
  width: 15%;
}
</style>
